module.exports = __webpack_public_path__ + "static/media/likedGreen.1abc745e.svg";